import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile, notificationStore, parseNumberByPrecision } from '@pascal/pascal-core';
import { AdditionalInputValueChangingButtons } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';

import { globalTranslationKeys } from '../../enums';

export const BetAmountSection = observer(
  ({
    t,
    isDemo,
    limits,
    onBlur,
    betAmount,
    setBetAmount,
    activeFreeBet,
    setIsValidatedAmount,
    handleChangeInputValue,
  }) => {
    const betValues = useMemo(() => {
      return [3, 5, 7];
    }, []);

    return (
      <div className='g-bot-area-btn-wr'>
        <div className='g-bot-area-inp-ins'>
          <div
            className={`g-bot-area-inp-left ${activeFreeBet.id && !isDemo ? 'passive' : ''}`}
            onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.divide)}
          >
            <span className='g-bot-ar-c-sp'>1/2</span>
          </div>
          <div className='g-bot-area-inp-center'>
            <span
              className={`inp-game-block minus ${activeFreeBet.id && !isDemo ? 'passive' : ''}`}
              onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.minus)}
            >
              <i className='ui-lib-minus'> </i>
            </span>
            <span
              className={`inp-game-block plus ${activeFreeBet.id && !isDemo ? 'passive' : ''}`}
              onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.plus)}
            >
              <i className='ui-lib-plus'> </i>
            </span>
            <input
              type='text'
              maxLength={9}
              autoComplete='off'
              readOnly={isMobile()}
              className='inp-game-c'
              value={activeFreeBet.id && !isDemo ? activeFreeBet.amount : betAmount || ''}
              onChange={(e) => {
                if (!/^[.,]/.test(e.target.value) && /^\d*[.,]?\d*$/.test(e.target.value)) {
                  setBetAmount(e.target.value.replace(',', '.'));
                }
              }}
              onBlur={() => {
                const { validatedBetAmount, errorMessageCode } = onBlur(betAmount);
                if (errorMessageCode) {
                  notificationStore.setNotificationType({ responseCode: errorMessageCode });
                  setIsValidatedAmount(true);
                }
                setBetAmount(validatedBetAmount);
              }}
            />
          </div>
          <div
            className={`g-bot-area-inp-left ${activeFreeBet.id && !isDemo ? 'passive' : ''}`}
            onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.multiply, 2)}
          >
            <span className='g-bot-ar-c-sp'>x2</span>
          </div>
        </div>
        <div className='g-bot-ar-btn-ins'>
          <div
            className={`g-bot-ar-btn-ins-item ${
              betAmount <= limits.minBet || (activeFreeBet.id && !isDemo) ? 'passive' : ''
            }`}
            onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.min)}
          >
            <span className='g-bot-ar-c-sp'>{t(globalTranslationKeys.Min)}</span>
          </div>
          {betValues.map((value) => (
            <div
              key={value}
              className={`g-bot-ar-btn-ins-item ${activeFreeBet.id && !isDemo ? 'passive' : ''}`}
              onClick={() => setBetAmount(parseNumberByPrecision(1, limits.minBet * value))}
            >
              <span className='g-bot-ar-c-sp'>
                {parseNumberByPrecision(1, limits.minBet * value)}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  }
);
